import { Button } from "@/components/ui/button";
import { dateIt } from "@/lib/format";
import { UserCheck } from "lucide-react";

export default function ProfiledCell({ item, onToggle, testKey, disabled }) {
  if (item.profiled) return (
    <button onClick={() => onToggle(item)} title={`Profilato da ${item.profiled_by || ""} il ${dateIt(item.profiled_at)} · clic per annullare`}
      className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-bold uppercase bg-sky-100 text-sky-800 hover:bg-sky-200 whitespace-nowrap"
      data-testid={`profiled-badge-${testKey}`}><UserCheck className="w-3.5 h-3.5" /> Profilato</button>
  );
  if (disabled) return <span className="text-slate-400 text-xs">—</span>;
  return <Button variant="outline" size="sm" className="whitespace-nowrap" onClick={() => onToggle(item)} data-testid={`mark-profiled-${testKey}`}>Segna Profilato</Button>;
}
